function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 1l8.067 8L17 1",
  stroke: "#160B2C",
  strokeWidth: 1.2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxMHB4IiB2aWV3Qm94PSIwIDAgMTggMTAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+UGF0aCAxMyBDb3B5IDg8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iQ2FyZWVycyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyMDEuMDAwMDAwLCAtMTU1Ni4wMDAwMDApIiBzdHJva2U9IiMxNjBCMkMiIHN0cm9rZS13aWR0aD0iMS4yIj4KICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoLTEzLUNvcHktOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIxMC4wMDAwMDAsIDE1NjEuMDAwMDAwKSByb3RhdGUoLTM2MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTIxMC4wMDAwMDAsIC0xNTYxLjAwMDAwMCkgIiBwb2ludHM9IjEyMDIgMTU1NyAxMjEwLjA2NjU3IDE1NjUgMTIxOCAxNTU3Ij48L3BvbHlsaW5lPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+IA==";
export { SvgArrowIcon as ReactComponent };